<script lang="ts" setup>
defineProps<{
  value: boolean
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

function closeGuide() {
  emit('input', false)
}
</script>

<template>
  <transition name="reader-guide-fade">
    <div
      v-if="value"
      class="reader-guide fixed inset-0 z-9999 flex items-center justify-center bg-black"
      @click.stop="closeGuide"
      @touchmove.prevent
    >
      <img
        src="/images/storyella/chapter/reader-taboola-guide.svg"
        class="w-full h-full object-cover"
        alt=""
      >
    </div>
  </transition>
</template>

<style scoped lang="scss">
.reader-guide {
  touch-action: none;
}

.reader-guide-fade-enter-active,
.reader-guide-fade-leave-active {
  transition: opacity 0.2s ease;
}

.reader-guide-fade-enter,
.reader-guide-fade-leave-to {
  opacity: 0;
}
</style>
